export default __webpack_public_path__ + "static/media/error.922c7839.gif";